import { z } from 'zod';

export const formSchema = z.object({
  carrierId: z.string({
    required_error: 'Selecione a transportadora',
  }),
  description: z.string().optional(),
});

export type FormSchema = z.infer<typeof formSchema>